import styled from 'styled-components'
import { Flex, Theme } from '@web-apps/ui-shared'

export const StyledMissedHintContainer = styled(Flex)`
  padding: 8px;
  background: ${Theme.Colors.background.alternate};
  border-radius: 8px;
`
